import PropTypes from 'prop-types';
import { formatRelativeWithOptions, isBefore, parseISO } from 'date-fns/esm/fp';
import { enUS } from 'date-fns/esm/locale';

const FormatRelative = ({
  date,
  hidePast,
  lastWeek,
  yesterday,
  today,
  tomorrow,
  nextWeek,
  other,
  className,
}) => {
  date = parseISO(date);
  const formatRelativeLocale = {
    lastWeek,
    yesterday,
    today,
    tomorrow,
    nextWeek,
    other,
  };

  const locale = {
    ...enUS,
    formatRelative: (token) => formatRelativeLocale[token],
  };

  const format = formatRelativeWithOptions({ locale });
  const hide = hidePast && isBefore(new Date(), date);

  return <p className={className}>{hide ? '' : format(new Date(), date)}</p>;
};

FormatRelative.propTypes = {
  date: PropTypes.string.isRequired,
  hidePast: PropTypes.bool,
  lastWeek: PropTypes.string,
  yesterday: PropTypes.string,
  today: PropTypes.string,
  tomorrow: PropTypes.string,
  nextWeek: PropTypes.string,
  other: PropTypes.string,
  className: PropTypes.string,
};

FormatRelative.defaultProps = {
  hidePast: false,
  lastWeek: "'Started last' eeee",
  yesterday: "'Started yesterday'",
  today: "'Starts today'",
  tomorrow: "'Starts tomorrow'",
  nextWeek: "'Starts on' eeee",
  other: "'Starts in' LLLL",
};

export default FormatRelative;
